const LOCAL_API = "http://127.0.0.1:47832";

let cached: string | null | undefined = undefined;

// Probes the local agent HTTP server (127.0.0.1:47832) to discover the agent
// ID of the computer this browser is running on. Returns null if the agent
// isn't installed or enrolled. Result is cached for the page lifetime.
export async function getLocalAgentId(): Promise<string | null> {
  if (cached !== undefined) return cached;
  try {
    const res = await fetch(`${LOCAL_API}/id`, {
      signal: AbortSignal.timeout(500),
    });
    if (!res.ok) {
      cached = null;
      return null;
    }
    const data = await res.json();
    cached = typeof data.agent_id === "string" ? data.agent_id : null;
  } catch {
    cached = null;
  }
  return cached ?? null;
}
